import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Input = styled.input`
  &[type='file'] {
    opacity: 0;
    width: 0;
  }
`

export const Label = styled.label`
  ${TypeStyle.css.headlineMicro};
  line-height: ${o => o.theme.typography.font.lineHeight.loose};
  text-transform: uppercase;
  border-radius: 4px;
  padding: ${o => o.theme.spacing(3)} 0;
  gap: ${o => o.theme.spacing(4)};
  display: flex;
  width: 100%;
  cursor: pointer;
  background-color: ${o => o.theme.color.deprecated.obsidian};
  color: white;
  justify-content: center;
  align-items: center;
  ${o => o.theme.typography.effect.uppercase};
  font-weight: ${o => o.theme.typography.font.weight[700]};
  &:hover {
    background-color: ${o => o.theme.color.text.secondary.on.background};
    border-color: ${o => o.theme.color.text.secondary.on.background};
    color: ${o => o.theme.color.fill.background};
  }
  &:focus-within {
    outline: 2px solid blue;
    outline-offset: 2px;
  }
`

export const Container = styled.div`
  width: 100%;
  margin: ${props => props.theme.spacing(6)} 0;
`
